import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function PricingSection() {
  return <section className="w-full py-24 px-6 bg-[#0a0f0d] border-t border-gray-900" data-id="element-58">
      <div className="max-w-3xl mx-auto text-center" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[#050505] border border-[#00d4aa]/30 p-8 md:p-16 rounded-2xl shadow-2xl shadow-[#00d4aa]/5" data-id="element-60">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-61">
            Sistema "Asistentes Listos"
          </h2>
          <p className="text-gray-400 mb-8" data-id="element-62">Para Infoproductos (sin código)</p>

          <div className="flex flex-col items-center justify-center space-y-2 mb-10" data-id="element-63">
            <div className="flex items-center space-x-4" data-id="element-64">
              <span className="text-2xl text-gray-500 line-through decoration-red-500/50 decoration-2" data-id="element-65">
                $19.080 ARS
              </span>
              <span className="bg-[#00d4aa]/10 text-[#00d4aa] px-3 py-1 rounded-full text-sm font-bold" data-id="element-66">
                50% OFF
              </span>
            </div>
            <span className="text-5xl md:text-6xl font-bold text-white tracking-tight" data-id="element-67">
              $9.540 ARS
            </span>
          </div>

          <a href="https://www.aprendeemprendearg.com/cart/52651469930863:1" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto bg-[#00d4aa] hover:bg-[#00bfa0] text-black font-bold text-lg px-8 py-4 rounded-lg transition-all transform hover:scale-105 flex items-center justify-center mx-auto space-x-2 no-underline" data-id="element-68">
            <span data-id="element-69">Consigue el ebook ahora</span>
            <ArrowRight className="w-5 h-5" data-id="element-70" />
          </a>

          <p className="mt-4 text-base text-[#00d4aa] font-medium" data-id="element-71">
            13 lecciones en video (1h 44m)
          </p>
          <p className="mt-1 text-sm text-gray-400" data-id="element-72">
            Sin relleno. Solo lo que necesitas para tener 3 asistentes
            funcionando.
          </p>

          <p className="mt-6 text-sm text-gray-500" data-id="element-73">
            Construye tus 3 asistentes en 72 horas. Acceso inmediato.
          </p>
        </motion.div>

        <div className="mt-16 text-gray-500 text-sm" data-id="element-74">
          <p data-id="element-75">
            Si quieres que la IA deje de ser un juguete y se convierta en un
            sistema.
          </p>
        </div>
      </div>
    </section>;
}